import { SourceComponents } from '@updater/informant-core';
import { SSNInput } from '@updater/ui-uds';

export const SSNField: SourceComponents['SSNField'] = (props) => {
  return <SSNInput {...props} />;
};
